function showDialog(context, configs = {}) {
  context.dialog = context.$createDialog(configs).show()
}

function showAlertDialog(context, content, confirm) {
  context.$createDialog({
    content: content || context.$t("ERROR_DEFAULT_TEXT"),
    icon: "cubeic-info",
    confirmBtn: {
      text: confirm || context.$t("确认")
    }
  }).show()
}

function showToast(context, configs = {}) {
  context.toast = context.$createToast(configs).show();
}

function showLoadingToast(context, txt, time = 0) {
  context.toast = context.$createToast({
    txt: txt || context.$t("加载中"),
    time,
    mask: true
  }).show();
}
export {
  showDialog,
  showAlertDialog,
  showToast,
  showLoadingToast
}
